/* global Sys, Core */
Sys.ns("Core.gameAdapterApi");

Core.gameAdapterApi.reactions = {
    EVENT: {
        GAME_HISTORY_REQUEST: "gameHistoryRequested",
        LOADED: "gameLoaded",
        DIALOG: "dialog",
        MODE_CHANGED: "modeChanged",
        ERROR: "error",
        INIT: "init",
        ENTERED_IDLE_FIRST_TIME: "enteredIdleFirstTime",
        BET_CHANGED: "betChanged",
        PRESENTATION_ENDED: "presentationEnded"
    },
    ERROR: {
        INSUFFICIENT_FUNDS: 10008
    },
    REVERT_ROUND_ERROR_CODES: [10008, 4001, 4002, 4003, 4004, 1051, 1012],

    createErrorReactionHandler: function(store, messageApi, services, observable) {
        var me = this;

        return function(errorCode) {
            // revertSpin is executed by ErrorManagerController
            if (me.REVERT_ROUND_ERROR_CODES.indexOf(errorCode) > -1 && services.gameRound.isRoundActive()) {
                observable.fireEvent("request:errorManager.revertSpin");
            }

            // don't add blocker because on oss wrapper side insufficientFunds error will trigger low balance pop-up
            if (errorCode !== me.ERROR.INSUFFICIENT_FUNDS) {
                store.setBlocker();
            }

            messageApi.sendMessageEvent(me.EVENT.ERROR, { errorCode: errorCode });
        };
    },

    errorReaction: function(store, messageApi, services, observable) {
        services.error.on("triggered", this.createErrorReactionHandler(store, messageApi, services, observable));
    },

    purgeDialogConfig: function(dialogConfig, store) {
        var purgedButtons = [],
            text;

        dialogConfig.buttons.forEach(function(button, index) {
            var buttonConfig;

            store.addButtonAction(button.action, index);

            buttonConfig = Object.keys(button)
                .filter(function(key) {
                    return key !== "action";
                })
                .reduce(function(acc, key) {
                    acc[key] = button[key];
                    return acc;
                }, {});

            purgedButtons.push(buttonConfig);
        });

        if (typeof dialogConfig.text === "string") {
            text = dialogConfig.text;
        }
        else {
            text = dialogConfig.text.reduce(function(acc, fragment) {
                return String(acc.toString() + " " + fragment.text);
            }, "");
        }

        return {
            id: dialogConfig.id,
            text: text,
            title: dialogConfig.title,
            buttons: purgedButtons
        };
    },

    createDialogReactionHandler: function(store, messageApi) {
        var me = this;

        return function(config) {
            var purgedConfig = me.purgeDialogConfig(config, store);

            store.setBlocker();

            messageApi.sendMessageEvent(me.EVENT.DIALOG, purgedConfig);
        };
    },

    dialogReaction: function(store, messageApi, services) {
        services.dialog.on("showOSSDialog", this.createDialogReactionHandler(store, messageApi));
    },

    onModeChangeReaction: function(messageApi, services) {
        services.game.on("modeChanged", this.createOnModeChangedReactionHandler(messageApi));
    },

    createOnModeChangedReactionHandler: function(messageApi) {
        var me = this;

        return function(mode) {
            messageApi.sendMessageEvent(me.EVENT.MODE_CHANGED, { mode: mode });
        };
    },

    createOnGameReadyReactionHandler: function(messageApi, services) {
        var me = this;

        return function() {
            var gameReadyState = {
                minBetCents: services.gameInformation.getGameInformation().minBet
            };

            messageApi.sendMessageEvent(me.EVENT.LOADED, gameReadyState);
        };
    },

    onGameReadyReaction: function(messageApi, services) {
        services.game.on("ready", this.createOnGameReadyReactionHandler(messageApi, services));
    },

    createOnGameHistoryRequestedReactionHandler: function(store, messageApi) {
        var me = this;

        return function() {
            store.setBlocker();

            messageApi.sendMessageEvent(me.EVENT.GAME_HISTORY_REQUEST);
        };
    },

    onGameHistoryRequestedReaction: function(store, messageApi, services) {
        services.game.on("gameHistoryRequested", this.createOnGameHistoryRequestedReactionHandler(store, messageApi));
    },

    createOnEnteredIdleFirstTimeReactionHandler: function(messageApi) {
        var me = this;

        return function() {
            messageApi.sendMessageEvent(me.EVENT.ENTERED_IDLE_FIRST_TIME);
        };
    },

    onEnteredIdleFirstTimeReaction: function(messageApi, services) {
        services.game.on("enteredIdleFirstTime", this.createOnEnteredIdleFirstTimeReactionHandler(messageApi));
    },

    createBetChangedHandler: function(messageApi, services) {
        var previousBet = -1,
            me = this,
            sendMessageIfDifference = function() {
                var currentBet = services.bet.getBetCash();

                if (previousBet !== currentBet) {
                    previousBet = currentBet;
                    messageApi.sendMessageEvent(me.EVENT.BET_CHANGED, { value: currentBet });
                }
            };

        // Change in a bet selector might trigger two 'changed' events from the bet service.
        return Sys.utils.debounce(sendMessageIfDifference, 50);
    },

    onBetChangedReaction: function(messageApi, services) {
        var betChangedHandler = this.createBetChangedHandler(messageApi, services);

        services.bet.on("changed", betChangedHandler);

        services.game.on("ready", betChangedHandler, true);

        services.response.on("restored", betChangedHandler, true);
    },

    createPresentationEndedHandler: function(messageApi, services) {
        var me = this;

        return function(isGameOver) {
            if (isGameOver) {
                messageApi.sendMessageEvent(me.EVENT.PRESENTATION_ENDED, {
                    winInCents: services.win.getTotalWinCash()
                });
            }
        };
    },

    onPresentationEndedReaction: function(messageApi, services) {
        services.gameRound.on(
            "presentationEnded",
            this.createPresentationEndedHandler(messageApi, services)
        );
    },

    init: function(store, messageApi, services) {
        var observable = new window.Sys.Observable(),
            reactionsList = [
                this.errorReaction.bind(this, store, messageApi, services, observable),
                this.dialogReaction.bind(this, store, messageApi, services),
                this.onModeChangeReaction.bind(this, messageApi, services),
                this.onGameReadyReaction.bind(this, messageApi, services),
                this.onGameHistoryRequestedReaction.bind(this, store, messageApi, services),
                this.onEnteredIdleFirstTimeReaction.bind(this, messageApi, services),
                this.onBetChangedReaction.bind(this, messageApi, services),
                this.onPresentationEndedReaction.bind(this, messageApi, services)
            ];

        reactionsList.forEach(function(reaction) {
            reaction();
        });
    }
};
